import { CONTROL_TYPE_ACCESS_CONTROL, CONTROL_TYPE_ALARM } from '@apps-common/config/controls'

export const getControlType = (controlTypeId: number, requiresControlState: boolean) => {
  if (controlTypeId === CONTROL_TYPE_ALARM || controlTypeId === CONTROL_TYPE_ACCESS_CONTROL) {
    return 'alarm'
  }
  return requiresControlState ? 'state' : 'generic'
}
